// extracted by mini-css-extract-plugin
export default {"paragraph":"style_paragraph__wAebS","word":"style_word__IPYct","shadow":"style_shadow__b7k2n"};